import LogoMenu from './LogoMenuComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAuth } from 'actions/auth/login';
import { getClientLogo } from 'actions/ui/init/initSelectors';
import { getHomeLink } from 'actions/auth/login';
import { getSideMenuOpen } from 'actions/ui/burgerMenu';
import { getSmallScreen } from 'actions/ui/browser';
import { action as toggleMenu } from 'redux-burger-menu';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  isOpen: getSideMenuOpen(state),
  isLoggedIn: getAuth(state),
  smallScreen: getSmallScreen(state),
  homeLink: getHomeLink(state),
  logo: getClientLogo(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleMenu
    },
    dispatch
  );

// Create higher-order component which feeds in specified props.
const LogoMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LogoMenu);

export default LogoMenuContainer;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LogoMenu/LogoMenuContainer.js